import React, { useEffect, useState } from "react";
import styles from "./NavigationPanel.module.css";
import LabeledIcon from "../common/LabeledIcon/LabeledIcon";
import Call from "../icons/Call";
import Email from "../icons/Email";
import Logout from "../icons/Logout";
import PortabilitySetting from "../icons/PortabilitySetting";
import Feedback from "../icons/Feedback";
import FAQs from "../icons/FAQs";
import { extractDomain } from "../utils";
import clearSessionAndCookieItem from "../utils/clearSessionAndCookieItem";

const dashboardActions = [
  {
    label: "Access & settings",
    svg: <PortabilitySetting />,
    href: "/v2/accountsettings/change_password.html",
  },
  {
    label: "Feedback",
    svg: <Feedback />,
    href: "/v2/accountsettings/change_password.html",
  },
  {
    label: "FAQs",
    svg: <FAQs />,
    href: "/v2/accountsettings/change_password.html",
  },
  {
    label: "Logout",
    svg: <Logout />,
    href: `${extractDomain()}/v2/logout.html`,
  },
];

function mapDashboardActionsHref(actions, userManagementData) {
  return actions
    .filter(
      (action) =>
        userManagementData &&
        userManagementData[action.label] !== undefined
    )
    .map((action) => {
      const updatedHref =
        action.label === "Knowledge Hub"
          ? knowledgeHubUrl
          : userManagementData[action.label] || action.href;
      return { ...action, href: updatedHref };
    });
}

export default function Sidebar(props) {
  const {
    showModal,
    setShowModal,
    image,
    userManagement,
    email,
    count,
    name,
    mobile,
    socialId,
    userName,
    logoutHref,
  } = props;

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [updatedDashboardActions, setUpdatedDashboardActions] = useState(null);
  const [modalTop, setModalTop] = useState(showModal ? "0" : "-100%");
  const logoutChannel = new BroadcastChannel("logout-channel");

  const onLogoutClick = () => {
    const keysToClear = [
      "chatCount",
      "chatServiceEnabled",
      "lastChatFetchTime",
      "userDetails",
      "initialVisit",
      "SESSION_STORAGE_SUBUID",
      "CLEVERTAP_PAGE_TRACKING",
      "dowdowloadsData",
      "dowloadsData",
      "alreadyDownloaded",
      "downloadsInProgress",
      "C",
    ];

    keysToClear.forEach(clearSessionAndCookieItem);
    localStorage.removeItem("downloadLeader");
    localStorage.removeItem("sessionId");
    localStorage.removeItem("downloadIntent"); 

    logoutChannel.postMessage({ type: "LOGOUT" });

    window.location.href = logoutHref;
  };

  useEffect(() => {
    setIsDrawerOpen(showModal);
    setModalTop(showModal ? "0" : "-100%");
  }, [showModal]);

  useEffect(() => {
    if (userManagement) {
      const actions = mapDashboardActionsHref(
        dashboardActions,
        userManagement
      );
      setUpdatedDashboardActions(actions);
    }
  }, [userManagement]);

  useEffect(() => {
    logoutChannel.onmessage = (event) => {
      if (event.data?.type === "LOGOUT") {
        const keysToClear = [
          "chatCount",
          "chatServiceEnabled",
          "lastChatFetchTime",
          "userDetails",
          "initialVisit",
          "SESSION_STORAGE_SUBUID",
          "CLEVERTAP_PAGE_TRACKING",
          "dowdowloadsData",
          "dowloadsData",
          "alreadyDownloaded",
          "downloadsInProgress",
          "C",
        ];
        keysToClear.forEach(clearSessionAndCookieItem);
        localStorage.removeItem("downloadLeader");
        localStorage.removeItem("sessionId");
        localStorage.removeItem("downloadIntent"); // ✅ release lock in all tabs

        window.location.href = logoutHref;
      }
    };

    return () => logoutChannel.close();
  }, []);

  const closeDrawer = (e) => {
    e.preventDefault();
    setIsDrawerOpen(false);
    setShowModal(false);
  };

  const modalDialogClassName = `${styles["modal-dialog"]} ${
    isDrawerOpen ? styles["show"] : ""
  }`;

  return (
    <>
      {isDrawerOpen && (
        <div className={styles["backdrop"]} onClick={closeDrawer}></div>
      )}

      <div
        className={modalDialogClassName}
        role="document"
        style={{ top: modalTop }}
      >
        <div className={styles["modal-content"]}>
          <div className={styles["user-details"]}>
            <div className={styles["profile-container"]}>
              <div className={styles["avatar-container"]}>
                {image && (
                  <div
                    className={styles["profile-image"]}
                    style={{ backgroundImage: `url(${image})` }}
                  ></div>
                )}
                <span
                  className={styles["name"]}
                  style={{
                    fontFamily: "Noto Sans, sans-serif !important",
                    fontSize: "16px",
                  }}
                >
                  {name || userName}
                </span>
              </div>
            </div>

            <div className={styles["contact-details-container"]}>
              <div className={styles["contact-details"]}>
                <LabeledIcon svg={<Call />} label={mobile || "N/A"} />
                <LabeledIcon svg={<Email />} label={email || "N/A"} />
              </div>
            </div>
          </div>

          {updatedDashboardActions &&
            updatedDashboardActions.map((item, index) => (
              <div key={index}>
                <a
                  className={`${styles["dashboard-actions-item"]} ${
                    item.label === "Logout" ? styles.logout : ""
                  }`}
                  href={item.href}
                >
                  <LabeledIcon svg={item.svg} label={item.label} />
                </a>
                {item.label === "Access & settings" && (
                  <div
                    style={{
                      borderTop: "1px solid #e7e7ea",
                      margin: "0 5px",
                    }}
                  ></div>
                )}
              </div>
            ))}

          <div
            style={{
              position: "absolute",
              bottom: 10,
              left: 0,
              width: "100%",
              display: "inline-block",
            }}
            className={`${styles["dashboard-actions-item"]} ${styles["logout"]}`}
            onClick={onLogoutClick}
          >
            <LabeledIcon svg={<Logout />} label="Logout" />
          </div>
        </div>

        <a
          href="/#"
          className={showModal ? styles["closebtn"] : ""}
          onClick={closeDrawer}
        >
          &times;
        </a>
      </div>
    </>
  );
}
